export const environment = {
  production: true,
  organisationsUrl: 'https://go.asx.care/api/v5/organisations.php',
  appKey: '689e738cf1bfd6bd741f04cb508113f8569ee910c78bca79e25da92f9ec12331',
  syncInterval: 1000 * 2,
  appVersion: '1.8.34',
  appVersionCode: 73
};
